import RaiseExemptionModel from "@/app/components/ui/Modals/RaiseExemption";
import SendPinModal from "@/app/components/routes/modals/SendPinWhatsappModal";
import ExamptionModalComponent from "../../../ClinicClosingComponent/ExamptionModalComponent";
import UnifiedCartCheckoutModal from "../../UnifiedCartCheckoutModal";
import BarcodeValidationModal from "@/app/components/routes/modals/BarcodeValidationModal";
import AddAddressModal from "../../../HDCart/AddAddressModal";
import AddressListModal from "../../../HDCart/AddressListModal";
import {
  ICartAddressDetails,
  ICartDetailsResponseData,
  ICartHdCartItem,
  IHDCartAddressListResponseData,
} from "@/api_framework/api_modals/Cart";

type ActiveModalType = "addressList" | "addAddress" | "addressClusterChange" | null;

interface CartModalsClusterProps {
  openMembershipExemption: boolean;
  setOpenMembershipExemption: (value: boolean) => void;
  customerName: string;
  customerId: string;
  mappedClinicId: string;
  onExemptionRefresh: () => Promise<void>;

  openCartPinExemptionModal: boolean;
  setOpenCartPinExemptionModal: (value: boolean) => void;
  selectedPinBookingId: string | undefined;
  onCartPinExemptionSuccess: () => Promise<void>;

  isCartPinSendModalOpen: boolean;
  setIsCartPinSendModalOpen: (value: boolean) => void;
  customerMobileNumber: string | undefined;
  onCartPinSendSuccess: () => void;

  checkoutModalOpen: boolean;
  setCheckoutModalOpen: (value: boolean) => void;
  currentAddress: IHDCartAddressListResponseData | null;
  activeCartDetails: ICartDetailsResponseData | null;
  activeCartId: string;
  availableHdItems: ICartHdCartItem[];
  handlePresent: (isPresent: string) => Promise<void>;
  callLogAPIBase: (item: any, event_type: "EMR_CART_CHECKOUT" | "CART_SELECTED_ADDRESS" | "CART_CHECKOUT_DETAILS") => void;
  selectedParavetId?: string;
  setActiveModal: (modalName: ActiveModalType) => void;

  isBarcodeSlideoverOpen: boolean;
  barcodeItemName: string | undefined;
  barcodeInputValue: string;
  showBarcodeMismatchError: boolean;
  onChangeBarcode: (value: string) => void;
  onCloseBarcodeValidation: () => void;
  onConfirmBarcodeValidation: () => void;

  activeModal: ActiveModalType;
  selectedAddressId: string | null;
  addressList: IHDCartAddressListResponseData[] | undefined;
  onCloseActiveModal: (modalName: ActiveModalType) => void;
  onAddressAdded: (address: any) => void;
  onSelectAddress: (address: ICartAddressDetails) => Promise<void>;
  onOpenAddAddressFromList: (addressId?: string) => void;
}

const CartModalsCluster = ({
  openMembershipExemption,
  setOpenMembershipExemption,
  customerName,
  customerId,
  mappedClinicId,
  onExemptionRefresh,
  openCartPinExemptionModal,
  setOpenCartPinExemptionModal,
  selectedPinBookingId,
  onCartPinExemptionSuccess,
  isCartPinSendModalOpen,
  setIsCartPinSendModalOpen,
  customerMobileNumber,
  onCartPinSendSuccess,
  checkoutModalOpen,
  setCheckoutModalOpen,
  currentAddress,
  activeCartDetails,
  activeCartId,
  availableHdItems,
  handlePresent,
  callLogAPIBase,
  selectedParavetId,
  setActiveModal,
  isBarcodeSlideoverOpen,
  barcodeItemName,
  barcodeInputValue,
  showBarcodeMismatchError,
  onChangeBarcode,
  onCloseBarcodeValidation,
  onConfirmBarcodeValidation,
  activeModal,
  selectedAddressId,
  addressList,
  onCloseActiveModal,
  onAddressAdded,
  onSelectAddress,
  onOpenAddAddressFromList,
}: CartModalsClusterProps) => (
  <>
    <RaiseExemptionModel
      open={openMembershipExemption}
      onClose={() => setOpenMembershipExemption(false)}
      customerName={customerName}
      customerId={customerId}
      clinicId={mappedClinicId}
      onRefresh={onExemptionRefresh}
    />
    <ExamptionModalComponent
      open={openCartPinExemptionModal}
      setOpen={setOpenCartPinExemptionModal}
      bookingDetails={selectedPinBookingId}
      exemptionIntent="user_profile_pin"
      fetchAppointmentData={onCartPinExemptionSuccess}
    />
    <SendPinModal
      open={isCartPinSendModalOpen}
      setOpen={setIsCartPinSendModalOpen}
      userId={customerId}
      userMobileNumber={customerMobileNumber}
      bookingId={selectedPinBookingId}
      clinicId={mappedClinicId}
      intent="checkout"
      onSuccess={onCartPinSendSuccess}
    />
    <UnifiedCartCheckoutModal
      open={checkoutModalOpen}
      setOpen={setCheckoutModalOpen}
      currentAddress={currentAddress}
      activeCartDetails={activeCartDetails}
      setActiveModal={setActiveModal}
      activeCartId={activeCartId}
      mappedClinicId={mappedClinicId}
      availableHdItems={availableHdItems}
      handlePresent={handlePresent}
      callLogAPIBase={callLogAPIBase}
      selectedParavetId={selectedParavetId}
    />
    <BarcodeValidationModal
      isOpen={isBarcodeSlideoverOpen}
      itemName={barcodeItemName}
      barcodeValue={barcodeInputValue}
      showMismatchError={showBarcodeMismatchError}
      onChangeBarcode={onChangeBarcode}
      onClose={onCloseBarcodeValidation}
      onConfirm={onConfirmBarcodeValidation}
    />
    {activeModal === "addAddress" && (
      <AddAddressModal
        source="cart"
        addressId={selectedAddressId}
        onClose={() => onCloseActiveModal(null)}
        onAddressAdded={onAddressAdded}
        currentAddress={currentAddress}
        setActiveModal={onCloseActiveModal}
        addAddressTitle=""
      />
    )}
    {activeModal === "addressList" && (
      <AddressListModal
        isAddressOpen={activeModal === "addressList"}
        onClose={() => setActiveModal(null)}
        payloadData={addressList}
        openAddAddress={onOpenAddAddressFromList}
        onSelectAddress={onSelectAddress}
      />
    )}
  </>
);

export default CartModalsCluster;
